//regular
import { faShoppingBasket } from '@fortawesome/pro-regular-svg-icons/faShoppingBasket';
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons/faAngleDown';
import { faAngleUp } from '@fortawesome/pro-regular-svg-icons/faAngleUp';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';

//export array
export const icons = [faShoppingBasket, faAngleDown, faAngleUp, faChevronDown];
